import { useEffect } from "react";

export default function Test() {
  useEffect(() => {
    const handleMessage = (event: any) => {
      console.log("Received message from iframe:", event.data);
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <iframe src="http://localhost:5173/ai/mobile" width="100%" height="100%" />
  );
}
